import React, { useState } from "react";
import { Button, TextField, Container, Typography, Box, Alert } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const PasswordResetRequest = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset error and success messages
    setError("");
    setSuccess(false);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/password-reset-request/`,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      if (response.status === 200) {
        setSuccess(true);  // Show success message
      }
    } catch (err) {
      console.error(err);
      setError("There was an issue sending the password reset email. Please try again.");
    }
  };

  return (
    <Box>
      <Box sx={{ textAlign: "center", bgcolor: "primary.dark", p: 4 }}>
        <Typography variant="h2" sx={{fontWeight:650, color:'white', cursor:'pointer'}} onClick={() => navigate('/')}>ExamPortal</Typography>
        <Typography variant="h6" sx={{ color: "white" }}>
          Efficient, Secure, and Painless Pre-Employment Testing
        </Typography>
      </Box>

      <Container maxWidth="xs">
        <Box sx={{ mt: 10 }} textAlign="center">
          <Typography variant="h4" gutterBottom>
            Request Password Reset
          </Typography>
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            If an account with that email exists, a password reset link has been sent.
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin="normal"
            label="Email Address"
            type="email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
          >
            Send Reset Link
          </Button>
        </form>
      </Container>
    </Box>
  );
};

export default PasswordResetRequest;
